export default {
  hello: "Hello",
};
